module.exports = __webpack_public_path__ + "static/media/ic_photo.752172ce.svg";